<template lang='pug' src='./block-tab-header.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      inSlide: false,
      outSlide: this.fade,
      animate: false,
      animation: 'fade'
    }
  },
  methods: {
    switchTab (i) {
      this.$store.dispatch('VIEW_TAB', i)
    }
  },
  created () {
    this.switchTab(0, this.props[0].tab)
  }
}
</script>
<style lang="css">

.slide-fade-enter-active {
  transition: all .75s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter {
  position: absolute;
  transform: translateX(10px);
  opacity: 0;
  z-index: 99;
  height: 0;
}
.slide-fade-leave-to {
  position: absolute;
  transform: translateX(-10px);
  opacity: 0;
  z-index: 98;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// block-tab-header.vue?18e7a874